import React from 'react';
import Icon from './Icon';

const ExpandDown = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <title>Expand Less</title>
    <path d="M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"/>
    <path d="M0 0h24v24H0z" fill="none"/>
  </Icon>
);

export default ExpandDown;
